import React, { useEffect, useState } from 'react';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { purchaseNotifications, IMAGES } from '../data/site';

/** Rotating social-proof notification: someone just purchased the digital system. */
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let showTimer: number;
    let hideTimer: number;
    const cycle = () => {
      setVisible(true);
      hideTimer = window.setTimeout(() => {
        setVisible(false);
        setIndex(prev => (prev + 1) % purchaseNotifications.length);
      }, 6000);
    };
    showTimer = window.setTimeout(cycle, 9000);
    return () => {
      window.clearTimeout(showTimer);
      window.clearTimeout(hideTimer);
    };
  }, [index, dismissed]);
  if (dismissed) return null;
  const item = purchaseNotifications[index];
  return <div aria-live="polite" className={`fixed bottom-24 left-3 right-3 z-30 transition-[transform,opacity] duration-200 ease-out sm:left-5 sm:right-auto sm:max-w-sm ${visible ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-3 opacity-0'}`} data-id="element-264" data-mp="165ze682cbfmc">
      <div className="flex items-center gap-3 rounded-2xl border border-navy/10 bg-white px-3 py-3 shadow-[0_18px_40px_-20px_rgba(12,21,38,0.45)]" data-id="element-265" data-mp="1fxn0xvnyc8hh">
        <img src={IMAGES.mainMockup} alt="" className="h-12 w-12 shrink-0 rounded-xl bg-sand object-contain p-1" data-id="element-266" data-mp="n86b95rpv5oy" />
        <div className="min-w-0 flex-1" data-id="element-267" data-mp="iaekif2t5pmc">
          <p className="truncate text-[13.5px] font-bold text-navy" data-id="element-268" data-mp="x6cblixvk3rp">{item.name}</p>
          <p className="text-[12px] leading-snug text-navy/65" data-id="element-269" data-mp="s5okyydk5oy0">
            just purchased Menopause Decision Desk™ · {item.place}
          </p>
          <p className="mt-0.5 flex items-center gap-1 text-[11px] font-semibold text-emerald-700" data-id="element-270" data-mp="28imvezun4pk0">
            <CheckCircle2Icon className="h-3 w-3" aria-hidden="true" data-id="element-271" data-mp="23l3j45hi6mup" />
            Verified purchase · a few minutes ago
          </p>
        </div>
        <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss notification" className="shrink-0 rounded-full p-1 text-navy/40 transition-colors duration-150 ease-out hover:bg-navy/5 hover:text-navy" data-id="element-272" data-mp="2fn4u2nwfm60d">
          <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-273" data-mp="2pjhkncwok3qw" />
        </button>
      </div>
    </div>;
}